import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './whatif.json'; // The JSON you provided

const Whatif = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Hypothetical scenarios and conditional practice. B2/C1 level grammar exercises focusing on conditionals and speculative language."
            level="B2"
            title="What If"
            image="/Images/whatif.webp"
            seoTitle="Free English Lesson Plans: What If"
            seoDescription="Hypothetical scenarios and conditional practice. B2/C1 level grammar exercises focusing on conditionals and speculative language."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Whatif;


